import actions from "./actions";

const initState = {
  reportDeleted: false,
  reports: {
    data: [],
  },
  loading: false,
  productReports: {
    data: [],
  },
  loadingProductReports: false,
};

export default function fetchReportsReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_REPORTS_REQUESTED:
      return {
        ...state,
        reports: {
          data: [],
        },
        loading: true,
      };
    case actions.FETCH_PRODUCTS_REPORTS_REQUESTED:
      return {
        ...state,
        productReports: {
          data: [],
        },
        loadingProductReports: true,
      };
    case actions.FETCH_PRODUCTS_REPORTS_SUCCEEDED:
      return {
        ...state,
        productReports: action.reports,
        loadingProductReports: false,
      };
    case actions.FETCH_PRODUCTS_REPORTS_FAILED:
      return {
        ...state,
        loadingProductReports: false,
      };

    case actions.FETCH_REPORTS_SUCCEEDED:
      return {
        ...state,
        reports: action.reports,
        loading: false,
      };
    case actions.FETCH_REPORTS_FAILED:
      return {
        ...state,
        loading: false,
      };

    case actions.DELETE_REPORT_REQUESTED:
      return {
        ...state,
        reportDeleted: false,
        loading: true,
      };
    case actions.DELETE_REPORT_SUCCEEDED:
      return {
        ...state,
        reportDeleted: true,
        loading: false,
      };
    case actions.DELETE_REPORT_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
